import { useNavigate } from 'react-router-dom';
import EditAndDeleteButton from '../../../components/button/EditAndDeleteButton';
import ProjectTableButton from '../../../components/button/ProjectTableButton';
import TableBaseButton from '../../../components/button/TableBaseButton';
import DisabledCheckbox from '../../../components/inputs/DisabledCheckbox';
import { ProjectsArray } from '../../../types/project/ProjectGetResponse';
import { formatProjectName } from '../../../utils/formatProjectName';

interface RenderProjectRowProps {
  item: ProjectsArray;
  editingId: number | null;
  onEditButtonClick: (item: ProjectsArray) => void;
  onDeleteButtonClick: (item: ProjectsArray) => void;
}

const RenderProjectRow = ({
  item,
  editingId,
  onEditButtonClick,
  onDeleteButtonClick,
}: RenderProjectRowProps) => {
  const navigate = useNavigate();

  return (
    <>
      <td>{item.projectNumber}</td>
      <td>{formatProjectName(item.projectName)}</td>
      <td>{item.clientName}</td>
      <td>{new Date(item.startDate).toLocaleDateString('ja-JP')}</td>
      <td>{new Date(item.endDate).toLocaleDateString('ja-JP')}</td>
      <td>
        <DisabledCheckbox checked={item.isUnproductive} />
      </td>
      <td>
        <DisabledCheckbox checked={item.isDairen} />
      </td>
      <td>
        <TableBaseButton
          onClick={() =>
            navigate(`/admin/assignment/${item.id}`, {
              state: { projectName: item.projectName },
            })
          }
          buttonText="参画社員を管理"
          className="btn btn-add-custom"
        />
      </td>
      <td>
        <TableBaseButton
          onClick={() => {
            navigate(`/admin/projects/${item.id}/costs`);
          }}
          buttonText="費用を管理"
          className="btn btn-add-custom"
        />
      </td>
      <td className="text-center" style={{ verticalAlign: 'middle' }}>
        <EditAndDeleteButton
          onEdit={() => onEditButtonClick(item)}
          onDelete={() => onDeleteButtonClick(item)}
          editingRowIndex={editingId}
        />
      </td>
    </>
  );
};

export default RenderProjectRow;
